export default "__VITE_ASSET__Bj57QH$7__"